import type { ManagerGetCampaignModel } from 'entities/campaign';
import { AlertBox } from 'shared/ui/AlertBox';
import { Button } from 'shared/ui/Button';
import { useModalsActions } from 'shared/ui/SideModal';
import { Switcher } from 'shared/ui/Switcher';
import { noop } from 'shared/lib/functions';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import { IntegrationsDataModal } from './IntegrationsDataModal';

export function EditIntegrations({ campaign }: { campaign: ManagerGetCampaignModel }) {
  const { open } = useModalsActions();
  const integrations = campaign.campaignIntegrations || [];

  return (
    <>
      <div className="my-8 border-t border-slate-100" />
      <div className="mb-4 flex items-center justify-between">
        <div className="text-lg font-semibold">CRM integrations</div>
        <Button
          dataTestId="TestId_manage_crm_notifications"
          type="button"
          onClick={() => {
            open(<IntegrationsDataModal campaign={campaign} />);
          }}
          variant="outline"
          size="medium"
          {...getDataAutoTestAttributes(['button-manage-crm-integrations'])}
        >
          <span className="text-sm">Manage</span>
        </Button>
      </div>
      {!integrations.length && (
        <AlertBox
          iconClass="text-deep-blue-500"
          iconName="miscellaneous_services"
          className="border-deep-blue-100"
        >
          <div className="mb-2 font-semibold text-slate-900">CRM integrations have not been added</div>
          <div className="text-slate-700">Add CRM integrations for the contractor to receive leads.</div>
        </AlertBox>
      )}
      {integrations.map((integration) => (
        <div
          key={integration.id}
          className="pointer-events-none mb-2 flex items-center justify-between rounded-md border border-slate-100 p-4 last:mb-0"
          {...getDataAutoTestAttributes(['switcher-manage-crm-integrations']).attributes}
        >
          <div className="text-sm text-slate-400">{integration.label}</div>
          <Switcher
            checked={integration.isActive}
            name={`isActive.${integration.id}`}
            className="opacity-60"
            onChange={noop}
          />
        </div>
      ))}
    </>
  );
}
